import { render, staticRenderFns } from "./ProjectSectorization.vue?vue&type=template&id=f9f9760e&scoped=true&"
import script from "./ProjectSectorization.vue?vue&type=script&lang=js&"
export * from "./ProjectSectorization.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSectorization.vue?vue&type=style&index=0&id=f9f9760e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f9760e",
  null
  
)

export default component.exports